import {inject, injectable} from 'inversify';

import type {ConferenceExpandFieldsCommon} from '../../../../api/conference';
import type {Expand} from '../../../../api/types';

import {conferenceExpandCommon} from '../../../../api/conference';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class ConferenceExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = conferenceExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace ConferenceExpandJrpc {
  export type ExpandedFields = ConferenceExpandFieldsCommon;
}
